export default __webpack_public_path__ + "static/media/02_Jahzzar_-_Chiefs.764fae44.mp3";